import {useCallback} from "react";
import {useIsAuthenticated} from "./useIsAuthenticated";
import {authEvents} from "@/shared/lib/events";

export const useRequireAuth = () => {
    const isAuthenticated = useIsAuthenticated();

    return useCallback((action: () => void) => {
        if (isAuthenticated) {
            action();
        } else {
            authEvents.loginRequired.emit();
        }
    }, [isAuthenticated]);
};
